import { UserStorageRepository } from 'application/repositories/UserStorageRepository';
import { User, UserToken } from 'domain/entities/UserEntity';
import { UserStorage } from 'infrastructure/storages/UserStorage';

export class UserStorageUseCase implements UserStorageUseCaseInterface {
    private userStorageUseCase: UserStorageRepository;

    constructor(userStorageRepo: UserStorageRepository) {
        this.userStorageUseCase = userStorageRepo;
    }

    getUserInfo(): UserToken | null {
        return this.userStorageUseCase.getUserInfo();
    }
    setUserInfo(user: UserToken): void {
        return this.userStorageUseCase.setUserInfo(user);
    }
    setUser(user: User): void {
        const userToken = this.getUserInfo();
        if (!userToken) return;
        userToken.user = user;
        this.setUserInfo(userToken);
    }
    removeUserInfo(): void {
        return this.userStorageUseCase.removeUserInfo();
    }
    getUserRoles(): string[] {
        return this.userStorageUseCase.getUserRoles();
    }
    getAccessToken(): string {
        return this.userStorageUseCase.getAccessToken();
    }
    getRefreshToken(): string {
        return this.userStorageUseCase.getAccessToken();
    }
}

export const userStorageUseCase = new UserStorageUseCase(new UserStorage());

export interface UserStorageUseCaseInterface {
    getUserInfo(): UserToken | null;
    setUserInfo(user: UserToken): void;
    setUser(user: User): void;
    removeUserInfo(): void;
    getUserRoles(): string[];
    getAccessToken(): string;
    getRefreshToken(): string;
}
